import React, { FC } from 'react'

import { AccordionInfo } from 'components'
import AccordionGlobalTitle from '../AccordionInfo/AccordionGlobalTitle'
import { useProjectParent } from 'modulesCommon/serviceHooks'
import { cn } from 'shared/utils'

import styles from './GlobalProjectInfo.module.scss'
import { useReactiveVar } from '@apollo/client'
import { activeProjectVar } from 'modulesCommon/store'

const GlobalProjectInfo: FC = () => {
  const activeProject = useReactiveVar(activeProjectVar)
  const parentProject = useProjectParent(activeProject)

  const list = [
    {
      title: <AccordionGlobalTitle title={'Global Team Info'} />,
      id: 'global-team-info',
      content: (
        <div
          className={cn(styles.textContent, 'ql-editor',  'ql-render')}
          dangerouslySetInnerHTML={{ __html: parentProject?.team_info ?? '' }}
        />
      ),
      expand: false
    },
    {
      title: <AccordionGlobalTitle title={'Global Project Info'} />,
      id: 'global-project-info',
      content: (
        <div
          className={cn(styles.textContent, 'ql-editor',  'ql-render')}
          dangerouslySetInnerHTML={{ __html: parentProject?.info ?? '' }}
        />
      ),
      expand: false
    }
  ]

  return <AccordionInfo list={list} />
}


export default GlobalProjectInfo
